<template>
    <div>
        <div class="authen" style="margin-left: 7%;">
            <!-- {{$global.webData}}----{{isPersion }} -->
            <div class="apply">
                <span>认证类型：</span>
                <div class="persion" :class="isPersion == 0 ? 'active' : ''" @click="isPersion = 0"
                     v-show="$global.webData.type != 1 && $global.webData.type != 2">个人认证
                </div>
                <div class="pommne" :class="isPersion == 1 ? 'active' : ''" @click="isPersion = 1"
                     v-show="companyAuthFlag">企业认证
                </div>
                <div class="pommne" :class="isPersion == 1 ? 'active' : ''" @click="isPersion = 1"
                     v-show="publicAuthFlag">对公认证
                </div>
            </div>
            <div class="aut_mess" v-show="isPersion == 0">
                <div class="account">
                    <div class="acte">姓名：</div>
                    <div class="input">
                        <el-input v-model="user.name"></el-input>
                    </div>
                </div>
                <div class="account">
                    <div class="acte">身份证号：</div>
                    <div class="input">
                        <el-input v-model="user.idCard"></el-input>
                    </div>
                </div>
                <div class="account">
                    <div class="acte">邮箱账号：</div>
                    <div class="key">{{user.emailName}}</div>
                </div>
                <div class="account" style="margin-top: 40px;">
                    <div class="acte">获取验证码：</div>
                    <div class="input">
                        <el-input v-model="user.code"></el-input>
                        <button class="btn" @click="handlCheckGetCode" :disabled="codeButt.status">{{codeButt.text}}
                        </button>
                    </div>
                </div>
                <div class="submin" @click="handlCheckAuthenSubmit">提交</div>
            </div>

        </div>
        <div class="authen" v-show="isPersion == 1">
            <div class="aut_mess" style="margin-left: 1%;">
                <!-- 企业认证表单 -->
                <div class="akmne" v-show="companyAuthFlag">
                    <div class="account">
                        <div class="iuten">法定代表人姓名：</div>
                        <div class="input">
                            <el-input v-model="enter.name"></el-input>
                        </div>
                    </div>
                    <div class="account">
                        <div class="iuten">法定代表人身份证号：</div>
                        <div class="input">
                            <el-input v-model="enter.idCard"></el-input>
                        </div>
                    </div>
                    <div class="account">
                        <div class="iuten">单位名称：</div>
                        <div class="input">
                            <el-input v-model="enter.panyName"></el-input>
                        </div>
                    </div>
                    <div class="account">
                        <div class="iuten">社会信用代码：</div>
                        <div class="input">
                            <el-input v-model="enter.code"></el-input>
                        </div>
                    </div>
                    <div class="account">
                        <div class="iuten">企业支付宝号：</div>
                        <div class="input">
                            <el-input v-model="enter.wxNum"></el-input>
                        </div>
                    </div>
                    <div class="submin" style="margin-left: 160px;" @click="handlCheckAuthenSubmit">提交</div>
                </div>
                <!-- 对公认证表单 -->
                <div class="akmne" v-show="publicAuthFlag">
                    <div class="account" style="margin: 40px 0;">
                        <div class="iuten">企业支付宝号：</div>
                        <div class="key">{{$store.store.state.userData.companyZfbId}}</div>
                    </div>
                    <div class="account">
                        <div class="iuten">请输入汇款金额：</div>
                        <div class="input">
                            <el-input v-model="publi.money"></el-input>
                        </div>
                    </div>
                    <div class="action">
                        <span>表单添加申请表：</span><img :src="publi.needImg" @click="$refs.busImgRef.click();"/>
                        <input type="file" id="fileExport" @change="handleFileChange($event)" ref="busImgRef"
                               style="display: none;">
                    </div>
                    <div class="submin" style="margin-left: 160px;" @click="handlCheckPublicSubmit">立即验证</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                codeButt: {
                    text: '获取验证码',
                    status: false,
                    value: ''
                },
                isPersion: null ,

                companyAuthFlag:false,
                publicAuthFlag:false,
                refusedFlag:false,

                user: {
                    name: '',
                    idCard: '',
                    emailName: this.$global.webData.email,
                    code: ''
                },
                enter: {
                    name: '',
                    idCard: '',
                    wxNum: '',
                    panyName: '',
                    code: ''
                },
                publi: {
                    money: '',
                    tableImg: '',
                    needImg: require('../../../../static/img/addImg.png'),
                    needImgPath: '',
                }
            }
        },
        mounted() {
            this.$emit('test', '四川相君科技有限公司');

            let userInfo = this.$global.webData;

            if( userInfo.type == 1 || userInfo.type == 2 ){
                this.isPersion =  1;
            }else{
                this.isPersion = 0
            }

            if( userInfo.type ==1 ){
                this.companyAuthFlag =true;
            }else if( userInfo.type == 2 ){

                if(userInfo.passStatus ==0 ){
                    if( userInfo.farenCode ){
                        this.companyAuthFlag =true;
                    }else{
                        this.companyAuthFlag =true;
                    }

                }else if(userInfo.passStatus == 2 ){
                    this.companyAuthFlag =true;
                    this.refusedFlag =true;
                }

            }



            // this.handlUserMember();
        },
        methods: {
            isPersionInput() {
                if (   this.user.name !== ''
                    && this.user.idCard !== ''
                    // && this.user.code !== ''
                    ) {
                    return true
                } else {
                    return false
                }
            },
            isEntInput() {
                if (   this.enter.name !== ''
                    && this.enter.idCard !== ''
                    && this.enter.panyName !== ''
                    && this.enter.code !== ''
                    // && this.enter.wxNum !== ''
                ) {
                    return true
                } else {
                    return false
                }
            },

            // 企业对公认证
            handlCheckPublicSubmit() {
                let _this = this;
                console.log(_this.publi.money, _this.publi.needImgPath)
                if (_this.publi.money && _this.publi.needImgPath) {
                    var param = new FormData();
                    param.append('token', _this.$global.token);
                    param.append('money', _this.publi.money);
                    param.append('moneyUrl', _this.publi.needImgPath);
                    _this.api.companyAuthor(param).then(res => {
                        console.log(res);
                        _this.$message.success('认证成功，请等待审核');
                        _this.$global.webData.authMoney = _this.publi.money;
                        localStorage.setItem('passState', 3);
                        _this.$router.push('loginMenu');


                        let formdata = new FormData();
                        formdata.append('token', _this.$global.token);
                        _this.$store.store.dispatch('getUserInfo', formdata);
                    })
                } else {
                    _this.$message.error('请完整输入所需内容');
                }

                // _this.handlUserMember();
            },
            // handlUserMember(){
            //   let formdata = new FormData();
            //   formdata.append('token',this.$global.token);
            //   this.xm.getUserMember(formdata).then(res => {
            //     this.$store.store.commit('handleUserData',res);
            //     location.reload();
            //   })
            // },

            // 个人认证 +  企业认证
            handlCheckAuthenSubmit() {
                let _this = this;
                var param = new FormData();
                // 个人认证
                if (_this.isPersion == 0) {
                    if (_this.isPersionInput()) {
                        param.append('type',  '1');
                        param.append('token', _this.$global.token);
                        param.append('code', _this.user.code);
                        param.append('email', _this.$global.webData.email);
                        param.append('name', _this.user.name);
                        param.append('idCard', _this.user.idCard);
                        // 【API请求】====个人信息认证
                        _this.api.memberAuthor(param).then(res => {
                            console.log(res);
                            _this.$message.success('个人认证成功');
                            _this.$global.webData.type = 1;
                            localStorage.setItem('passState', 1);
                            _this.$router.push('loginMenu');
                        })
                        // _this.handlUserMember();
                    } else {
                        _this.$message.error('请完整输入所需内容');
                    }
                } else { // 企业认证
                    if (_this.isEntInput()) {

                        if(this.refusedFlag){
                            param.append('type',  '2');
                        }else{
                            param.append('type',   '1' );
                        }

                        param.append('token', _this.$global.token);
                        param.append('companyName', _this.enter.panyName);
                        param.append('companyZfbId', _this.enter.wxNum);
                        param.append('creditCode', _this.enter.code);
                        param.append('farenCode', _this.enter.idCard);
                        param.append('farenName', _this.enter.name);
                         // 【API请求】====企业信息认证
                        _this.api.memberAuthor(param).then(res => {
                            console.log(res);
                            _this.$message.success('认证成功');
                            _this.$global.webData.farenCode = _this.enter.code;
                            _this.$global.webData.type = 2;
                            _this.$global.webData.companyZfbId = _this.enter.wxNum;
                            localStorage.setItem('passState', 2);

                            //
                            //_this.companyAuthFlag = false
                            //_this.publicAuthFlag = true

                            _this.$router.push({
                                path: '/loginMenu'
                            })

                            _this.isPersion = 1
                        })
                        // _this.handlUserMember();
                    } else {
                        _this.$message.error('请完整输入所需内容');
                    }

                }
            },
            handlCheckGetCode() {
                this.codeButt.status = true;
                let countdown = 60;
                let _this = this;
                let param = new FormData();
                param.append('email', _this.$global.webData.email);
                param.append('type', '1');
                _this.api.sendCodeToEmail(param).then(res => {
                    console.log(res);
                    _this.$message.success('发送成功');
                    _this.codeButt.text = countdown + '秒';
                    _this.codeButt.status = true;
                    let timer = setInterval(() => {
                        if (countdown > 0) {
                            _this.codeButt.text = countdown - 1 + '秒';
                            countdown--;
                        } else {
                            clearInterval(timer);
                            _this.codeButt.text = '获取验证码';
                            _this.codeButt.status = false;
                        }
                    }, 1000);
                }).catch(e => {
                    this.codeButt.status = false;
                })
            },
            handleFileChange(e) {
                let file = e.currentTarget.files[0];
                let size = Math.floor(file.size / 1024);
                this.publi.needImg = this.xm.getObjectURL(file);
                this.getUplodPath(file);
                e.target.value = '';
            },
            async getUplodPath(file) {
                let formdata = new FormData();
                formdata.append('file', file);
                let _this = this;
                let post = () => {
                    return new Promise((resolve, reject) => {
                        _this.api.upload(formdata).then(res => {
                            console.log(res);
                            resolve(res.path);
                            _this.$global.showPath = res.path;
                        })
                    });
                }
                this.publi.needImgPath = await post();

            },
        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    .authen {
        width: @a;
        height: auto;

        .apply {
            width: @a;
            height: 60px;
            display: flex;
            align-items: center;

            span {
                width: 190px;
                height: auto;
                font-family: MicrosoftYaHei-Bold;
                font-size: 24px;
                font-weight: bolder;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #333333;
                text-align: end;
            }

            .active {
                background-image: linear-gradient(270deg,
                #1e6eee 0%,
                #109ee7 50%,
                #01cee0 100%),
                linear-gradient(#000000,
                #000000);
                background-blend-mode: normal,
                normal;
                box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                color: #fff !important;
            }

            .persion {
                width: 260px;
                height: 60px;
                background-color: #fff;
                border: solid 1px #aaaaaa;
                letter-spacing: 1px;
                color: #333333;
                font-size: 24px;
                line-height: 60px;
                text-align: center;
                cursor: pointer;
            }

            .pommne {
                width: 260px;
                height: 60px;
                background-color: #fff;
                border: solid 1px #aaaaaa;
                letter-spacing: 1px;
                color: #333333;
                font-size: 24px;
                line-height: 60px;
                text-align: center;
                cursor: pointer;
            }
        }

        .aut_mess {
            width: @a;
            height: auto;

            .akmne {
                width: @a;
                height: auto;
            }

            .submin {
                width: 520px;
                height: 80px;
                line-height: 80px;
                margin-top: 50px;
                text-align: center;
                letter-spacing: 1px;
                color: #ffffff;
                font-size: 24px;
                background-image: linear-gradient(270deg,
                #1e6eee 0%,
                #109ee7 50%,
                #01cee0 100%),
                linear-gradient(#000000,
                #000000);
                background-blend-mode: normal,
                normal;
                box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                margin-left: 150px;
                cursor: pointer;
            }

            .account {
                width: 100%;
                height: auto;
                display: @flex;
                align-items: center;
                margin-top: 30px;

                .acte {
                    width: 190px;
                    height: auto;
                    font-family: MicrosoftYaHei-Bold;
                    font-size: 24px;
                    font-weight: bolder;
                    font-stretch: normal;
                    letter-spacing: 1px;
                    color: #333333;
                    text-align: end;
                }

                .iuten {
                    width: 260px;
                    height: auto;
                    font-family: MicrosoftYaHei-Bold;
                    font-size: 24px;
                    font-weight: bolder;
                    font-stretch: normal;
                    letter-spacing: 1px;
                    color: #333333;
                    text-align: end;
                }

                .key {
                    width: 280px;
                    height: 25px;
                    font-family: MicrosoftYaHei-Bold;
                    font-size: 24px;
                    font-weight: bolder;
                    font-stretch: normal;
                    letter-spacing: 1px;
                    color: #333333;
                }

                .input {
                    width: 520px;
                    height: 60px;
                    position: relative;

                    /deep/ .el-input__inner {
                        width: 520px;
                        height: 60px;
                    }

                    .btn {
                        width: 150px;
                        height: 60px;
                        line-height: 60px;
                        text-align: center;
                        cursor: pointer;
                        background-color: #f5f5f5;
                        border: solid 1px #aaaaaa;
                        letter-spacing: 1px;
                        color: #333333;
                        position: absolute;
                        right: 0;
                        bottom: 0;
                    }
                }
            }

            .action {
                width: @a;
                height: 170px;
                display: @flex;
                margin-top: 30px;

                .select {
                    width: auto;
                    height: auto;
                    margin-left: 33px;
                }

                .sempetImg {
                    margin: 30px 0;
                }

                span {
                    width: 220px;
                    font-family: MicrosoftYaHei-Bold;
                    font-size: 24px;
                    font-weight: bolder;
                    font-stretch: normal;
                    letter-spacing: 1px;
                    color: #333333;
                    text-align: end;
                }

                img {
                    width: 170px;
                    height: 170px;
                    cursor: pointer;
                    object-fit: cover;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/authentication/authen.vue